import styled from "styled-components";

const FiltersContainer = styled('div')`
  grid-area: filters;
  display: flex;
  flex-direction: column;
`;

export default FiltersContainer;
